import { API_ERROR_CODES, API_ERROR_MESSAGES } from '../onboarding-api';
import { translationKeys } from '../translations/translationKeys';

const ERROR_CODE_TRANSLATION_MAP: Record<string, translationKeys> = {
  [API_ERROR_CODES.GENERIC]: translationKeys.API_ERROR_CODES_GENERIC,
  [API_ERROR_CODES.LOGIN_TOO_MANY_ATTEMPTS]: translationKeys.API_ERROR_CODES_LOGIN_TOO_MANY_ATTEMPTS,
  [API_ERROR_CODES.LOGIN_GENERIC]: translationKeys.API_ERROR_CODES_LOGIN_GENERIC,
  [API_ERROR_CODES.PASSWORD_BLACKLISTED]: translationKeys.API_ERROR_CODES_PASSWORD_BLACKLISTED,
};

export function getTranslatedApiError(
  errorCode: API_ERROR_CODES,
  translate: (key: translationKeys) => string,
  rawErrorMessage?: string
): string {
  const key = ERROR_CODE_TRANSLATION_MAP[errorCode];
  const translated = key ? translate(key) : null;
  // If translate returns the key itself, the translation is missing — fall back
  if (translated && translated !== key) return translated;
  return rawErrorMessage || API_ERROR_MESSAGES[errorCode] || '';
}
